export default {
  title: 'SEO',
  subtitle:
    'Personalizza il titolo e la descrizione visualizzati nei risultati Google e nelle anteprime social. Lascia vuoto per usare i valori predefiniti.',
  fields: {
    title: {
      label: 'Titolo pagina',
      placeholder: 'es. Forza Napoli — autentica pizza napoletana a Monaco',
      help: 'Mostrato come titolo nei risultati Google e nelle schede del browser. Fino a 255 caratteri; punta a 50–60 per la migliore anteprima.',
    },
    description: {
      label: 'Meta descrizione',
      placeholder: 'Breve descrizione del ristorante che apparirà sotto il titolo nei risultati di ricerca.',
      help: 'Fino a 500 caratteri; Google ne mostra tipicamente 150–160. Evidenzia ciò che rende unico il tuo ristorante.',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    saved: 'Impostazioni SEO salvate',
    failed: 'Salvataggio delle impostazioni SEO non riuscito',
  },
};
